export default "__VITE_ASSET__FDXlpR_Q__"